// @core/api/endpoints/task/get_task.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Get task
 * Retrieves complete task details including description, status, assignees, checklists, and linked resources.
 */
export async function GetTask(
  task_id: string,
  options?: RequestOptions
): Promise<TaskResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.get<TaskResponse>(requestPath, { ...requestOptions });
}
